module.exports = __webpack_public_path__ + "static/img/bg-info.bf40da9c.png";